import { parseResponse } from "../../utils/common_lib";
import { baseApi } from "../baseApi";
export const patientLettersApi = baseApi.injectEndpoints({
  tagTypes: ['PatientLetters'],
  endpoints: (builder) => ({
    getPatientLetters: builder.query({
      query: (params) => {
        return {
          url: `/ClinicalTemplate/get_letters.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => {return parseResponse(response);},
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetPatientLettersQuery } = patientLettersApi;
